<template>
  <div class="programsView main_view">
    <header-comp/>
    <div class="view_grid">
      <navbar-comp :active="'programs'" class="navbar"/>
      <programs-comp v-if="show == 'all'"/>
      <program-comp v-if="show == 'one'"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'programsView',
  components: {
  },
  data: function () {
    return {
      moduleName: 'programs',
      config: {
        moduleName: 'config'
      }
    }
  },
  computed: {
    show: function () { return this.$store.getters[`${this.moduleName}/getShow`] }
  },
  created: function () {
    this.$store.dispatch(`${this.config.moduleName}/get`, {})
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
